export const enum SnackbarTypeEnum {
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
  SUCCESS = 'success',
  NONE = 'none',
}
